export default __webpack_public_path__ + "static/Economic Model Update - Portuguese-042a4594eb152ed1276fe82b83151766.pdf";